export const SKOLTEND_INTRO_FAQS = [
  {
    question: "Skoltend 提供甚麼資訊？",
    answer: "Skoltend 提供香港學校招標及書面報價資訊，涵蓋資訊科技、工程維修、膳食、清潔及其他採購類別，方便供應商集中搜尋相關項目。",
  },
  {
    question: "如何尋找適合自己公司的學校招標？",
    answer: "你可以在招標列表按業務類別及目標地區篩選，再配合關鍵字、招標狀態及截止日期縮小範圍。例如，資訊科技供應商可以先選擇「資訊科技」，再查看符合服務地區及投標時間的項目。",
  },
  {
    question: "未訂閱付費會員，可以查看甚麼？",
    answer: "你可以瀏覽招標的公開摘要，包括標題、地區、分類、截止日期及招標狀態。個別招標的學校身份、詳細說明、聯絡資料、來源連結及文件屬付費會員專屬內容。",
  },
  {
    question: "付費會員可以查看哪些額外資料？",
    answer: "付費會員可查看平台已收錄的招標學校身份、詳細說明、聯絡資料、來源連結及招標文件。不同項目的資料完整程度可能有所不同；實際會員權益請參閱「會員計劃」。",
  },
  {
    question: "Skoltend 是學校的官方投標渠道嗎？",
    answer: "不是。Skoltend 是獨立的招標資訊平台，並不代表教育局或發標學校。供應商應按照學校正式招標文件指定的方式提交標書或報價，並直接向發標學校確認要求。",
  },
  {
    question: "投標前應核對哪些資料？",
    answer: "請核對最新的招標文件、投標資格、所需附件、提交方式、截止日期及時間，並留意學校有沒有發出補充文件、更正或延期通知。平台資訊供搜尋及參考之用，正式要求以發標學校最新公布為準。",
  },
] as const;
